import { Public } from 'modules/router/types';

import CoverBuilder from 'modules/coverEditor';

const regularRoutes = [{ type: Public, exact: true, path: '/', component: CoverBuilder }];

export const routes = [].concat(regularRoutes);
